import React from 'react'
import { BarTrack, BarSegment } from './style'

const ThreatImpactBar = ({ total, segments }) => {
  return (
    <BarTrack>
      {segments
        .filter((segment) => segment.value > 0)
        .map((segment) => (
          <BarSegment key={segment.key} $widthPercent={(segment.value / total) * 100} color={segment.color} />
        ))}
    </BarTrack>
  )
}

export default ThreatImpactBar